export default {
      id: "ic_warning-usage",
      viewBox: "0 0 24 21",
      url: "/" + "images/icons.3.109.2.svg#ic_warning-usage",
      toString: function () {
        return this.url;
      }
    }